import React, { useState, useEffect, useRef } from "react";
import FontPicker from "font-picker-react";
import TabbedPanel from "../../../../components/TabbedPanel/TabbedPanel";
import FormDropDown from "../../../../components/forms/DropDownList/FormDropDown";
import { applyFontPreview, FontPreviewBlock, getCustomFontUrl } from "../../../../helpers/CustomFonts";
import { slideOutPanelControl } from "../SlideoutPanel";
import LottieIcon from "../../../../components/common/LottieIcon";
import FeatureTemplatePicker from "../../../Campaigns/FeatureTemplatePicker";
import config from "../../../../config";
import { getIconCategoryClass } from "../../../../components/common/iconCategory";
import './DisruptorSelectorContent.scss';

const toDisplayUrl = (url) =>
    url && url.startsWith('/files/') ? `${config.apiBaseUrl}${url}` : (url || '');

const DisruptorSelectorContent = (props) => {
    console.log("Rendering DisruptorSelectorContent with props:", props);
    const [viewMode, setViewMode] = useState('standard'); // 'standard' | 'template'
    const [isApplyingTemplate, setIsApplyingTemplate] = useState(false);

    const restrictItemsToVarKey = props.customisationSchema.subType;
    const availableLibraryItems = [];
    for (let i = 0; i < props.libraryItems?.Campaign?.length; i++) {
        const item = props.libraryItems.Campaign[i];
        if (item.id !== props.selectedFeatureNode.id && (item.varKey === restrictItemsToVarKey || restrictItemsToVarKey === undefined || restrictItemsToVarKey === null || restrictItemsToVarKey === '')) {
            availableLibraryItems.push(item);
        }
    }

    const handleSelectDisruptor = (disruptorId) => {
        console.log('Selected disruptor ID:', disruptorId);
        if (props.onDisruptorSelected) {
            props.onDisruptorSelected(disruptorId);
        }
    }

    const handleTemplateSelected = (templateId) => {
        if (!props.onAddFromTemplate) return;
        setIsApplyingTemplate(true);
        props.onAddFromTemplate(templateId, (success, newFeatureId) => {
            setIsApplyingTemplate(false);
            if (success && newFeatureId && props.onDisruptorSelected) {
                props.onDisruptorSelected(newFeatureId);
                setViewMode('standard');
            } else if (success) {
                setViewMode('standard');
            }
        });
    };

    return (
        <div className="library-tab-content" onWheel={(e) => e.stopPropagation()}>
            {props.onAddFromTemplate && (
                <div className="ftp-mode-tabs">
                    <button
                        className={`ftp-mode-tab${viewMode === 'standard' ? ' active' : ''}`}
                        onClick={() => setViewMode('standard')}
                    >
                        Existing Features
                    </button>
                    <button
                        className={`ftp-mode-tab${viewMode === 'template' ? ' active' : ''}`}
                        onClick={() => setViewMode('template')}
                    >
                        From Template
                    </button>
                </div>
            )}

            {viewMode === 'template' && (
                isApplyingTemplate ? (
                    <p className="ftp-applying">Applying template…</p>
                ) : (
                    <div className="disruptor-template-picker">
                        <FeatureTemplatePicker
                            onSelect={handleTemplateSelected}
                            embedded
                            featuresList={props.featuresList}
                        />
                    </div>
                )
            )}

            {viewMode === 'standard' && <>
            <div className="v2-select-disruptor-grid">
                {availableLibraryItems.length === 0 && (
                    <div>
                        No disruptors available to add. You may need to add some disruptor features to your campaign first.
                    </div>
                )}
                {availableLibraryItems.length > 0 && availableLibraryItems.map((item) => {
                    const iconCatSlug = getIconCategoryClass(((Array.isArray(item.itemCategory) ? item.itemCategory[0] : item.itemCategory) || item.category) || 'misc');
                    if (item.fromTemplateName) {
                        // Template-origin feature — render as ftp-card (image + icon badge + template name)
                        return (
                            <div
                                key={`${item.id}-${item.label}`}
                                className={`ftp-card${props.currentDisruptor === item.id ? ' active' : ''}`}
                                onClick={() => handleSelectDisruptor(item.id)}
                            >
                                <div className="ftp-card-img-wrap">
                                    <div
                                        className="ftp-card-img"
                                        style={item.fromTemplateImage ? { backgroundImage: `url(${toDisplayUrl(item.fromTemplateImage)})` } : {}}
                                    />
                                    <div className={`ftp-icon-badge category-icon-bg--${iconCatSlug}`}>
                                        <LottieIcon icon={item.icon} varKey={item.varKey} size={20} />
                                    </div>
                                </div>
                                <div className="ftp-card-label">{item.fromTemplateName}</div>
                            </div>
                        );
                    }
                    return (
                        <div
                            key={`${item.id}-${item.label}`}
                            className={`library-item-card${props.currentDisruptor === item.id ? ' active' : ''}`}
                            onClick={() => handleSelectDisruptor(item.id)}
                        >
                            <div className={`item-image-placeholder category-icon-bg--${iconCatSlug}`}>
                            <LottieIcon icon={item.icon} varKey={item.varKey} size={40} />
                            </div>
                            <div className="item-name">{item.label}</div>
                        </div>
                    );
                })}
            </div>
            <div className="selected-disruptor-info">
                <div className="remove-button-row">
                    <div 
                        className="clear-disruptor-link"
                        onClick={() => handleSelectDisruptor('')}
                    >
                        Clear Selection
                    </div>
                </div>
            </div>
            </>}
        </div>
    )
}

export default DisruptorSelectorContent;
